import React from 'react';
import { logout } from '../utils/auth';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error('Error caught by boundary:', error, errorInfo);

    // Check if it's an unauthorized error
    if (error.message && error.message.includes('Unauthorized')) {
      logout();
    }
    // Do NOT logout for subscription errors

  }

  render() {
    if (this.state.hasError) {
      // Check if it's an unauthorized error
      if (this.state.error && this.state.error.message &&
        this.state.error.message.includes('Unauthorized')) {
        return null; // Let the logout redirect handle this
      }

      return (
        <div className="error-boundary">
          <h2>Something went wrong.</h2>
          <p>Please try refreshing the page or contact support if the problem persists.</p>
          <button
            onClick={() => window.location.reload()}
            className="btn btn-primary"
          >
            Refresh Page
          </button>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary; 